import type { ApplicationState, ApplicationType } from "@/features/onboarding/onboarding.types";
import { JOURNEY_STEPS, type JourneyStepId } from "./journeySteps";

// Mirrors lendcord-core's ApplicationJourney — only BORROWER goes through
// LOAN_DETAILS_VERIFICATION/CIBIL_VERIFICATION (loan terms + a CRIF credit
// check). LENDER/STAFF/AGENT have no loan to set terms on or credit-check, so
// their Stepper skips straight from Verification to Notification.
const STEPS_SKIPPED_FOR_NON_BORROWER: JourneyStepId[] = ["LOAN_DETAILS_VERIFICATION", "CIBIL_VERIFICATION"];

export function getJourneySteps(applicationType: ApplicationType): typeof JOURNEY_STEPS {
  if (applicationType === "BORROWER") return JOURNEY_STEPS;
  return JOURNEY_STEPS.filter((step) => !STEPS_SKIPPED_FOR_NON_BORROWER.includes(step.id));
}

export function getStateOrder(applicationType: ApplicationType): ApplicationState[] {
  return getJourneySteps(applicationType)
    .slice(1)
    .map((step) => step.id as ApplicationState);
}

// Only BORROWER applications render LoanTermsStep/CrifStep at VERIFIED/
// LOAN_DETAILS_VERIFICATION/CIBIL_VERIFICATION — every other type goes
// straight from VERIFIED to an approval decision with no loan terms or CRIF
// check in between.
export function requiresLoanTermsAndCrif(applicationType: ApplicationType): boolean {
  return applicationType === "BORROWER";
}
